import { Position } from './Position';
import { GraphModel } from './GraphModel';

export class MainAccountDto {
  position: Position;
  graph: Array<GraphModel> | undefined;
}
